import { FormHookItemPropsModel } from 'Components/ReactFormHook/FormHookItem/formHookItem';
import { DTOOrderVATInfo } from 'Services/v1/cargo-direct/dto';
import { PopupConfigModel } from 'Hooks';

const InvoiceIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="invoice-grad-0" x1="15.4352" y1="0.343262" x2="9.5" y2="10.3431" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--s247-icon-start, #AC2B90)"/>
        <stop offset="1" stopColor="var(--s247-icon-end, #EE5B33)"/>
      </linearGradient>
      <linearGradient id="invoice-grad-1" x1="17" y1="-5.65686" x2="-7" y2="32.8431" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--s247-icon-start, #AC2B90)"/>
        <stop offset="1" stopColor="var(--s247-icon-end, #EE5B33)"/>
      </linearGradient>
    </defs>
    <path d="M13.138 6.27607H18.4016L12.4688 0.343262V5.60677C12.4688 5.97685 12.7683 6.27607 13.138 6.27607Z" fill="url(#invoice-grad-0)"/>
    <path d="M13.1387 7.44793C12.1201 7.44793 11.2975 6.62359 11.2975 5.6068V0H3.09703C2.07844 0 1.25586 0.824414 1.25586 1.84113V18.1588C1.25586 19.1773 2.08008 20 3.09699 20H16.9043C17.9195 20 18.7454 19.174 18.7454 18.1588V7.44789H13.1387V7.44793Z" fill="url(#invoice-grad-1)"/>
  </svg>
);

export const E_INVOICE_FORM_CONSTANT: Array<
	FormHookItemPropsModel<DTOOrderVATInfo>
> = [
	{
		placeholder: 'placeholder_vat_email',
		label: 'Email',
		field: 'email',
		required: true,
		pattern: {
			value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
			message: 'validation_email_pattern',
		},
		className: 'einvoice-form-field-container',
	},
	{
		placeholder: 'placeholder_vat_company_name',
		label: 'label_vat_company_name',
		field: 'companyName',
		required: true,
		className: 'einvoice-form-field-container',
	},
	{
		placeholder: 'placeholder_vat_company_address',
		label: 'label_vat_company_address',
		field: 'companyAddress',
		required: true,
		className: 'einvoice-form-field-container',
	},
	{
		placeholder: 'placeholder_vat_tax_number',
		label: 'label_vat_tax_number',
		field: 'taxNumber',
		required: true,
		className: 'einvoice-form-field-container',
	},
];

export const E_INVOICE_POPUP_CONFIG: PopupConfigModel = {
	icon: <InvoiceIcon />,
	title: 'title_vat_form',
	hideFooter: true,
};
